export const COMPANIES_ICONS = [
  { icon: require('builder/components/CIO-Dasboard-2.0/assets/GoogleIcon.svg'), alt: 'Google' },
  { icon: require('builder/components/CIO-Dasboard-2.0/assets/AppleIcon.svg'), alt: 'Apple' },
  { icon: require('builder/components/CIO-Dasboard-2.0/assets/AmazonIcon.svg'), alt: 'Amazon' },
]
